import { render, staticRenderFns } from "./addProductDialog.vue?vue&type=template&id=4b7b2598&scoped=true&"
import script from "./addProductDialog.vue?vue&type=script&lang=js&"
export * from "./addProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./addProductDialog.vue?vue&type=style&index=0&id=4b7b2598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7b2598",
  null
  
)

export default component.exports